import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetEtfViewSummaryBlockRequest extends BaseServiceRequest {
    constructor(msid, symbol, endDate, targetCurrencyCode) {
        super();
        super.addPathParameter(msid.toString());
        super.addRequestParameter("sym", symbol);
        super.addRequestParameter("end", endDate);
        super.addRequestParameter("tgc", targetCurrencyCode);
        super.addRequestUri("etfsumblock.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "ETFSummaryBlockResponse";
    }
}

export default GetEtfViewSummaryBlockRequest;
